import requestProvider from "./axiosHandler";

const getAllAppointment = () => {

    return requestProvider
        .get('/appointment/get-all')
}

const createAppointment = (list) => {
    return requestProvider
        .post('/appointment', list)
}

const updateAppointment = (list) => {
    return requestProvider
        .put('/appointment', list);
}

const deleteAppointment = (id) => {
    return requestProvider
        .delete(`/appointment/${id}`)
}

const getAppointmentById = (id) => {
    return requestProvider
        .get(`/appointment/${id}`)
}

const getOwnAppointments = () => {

    return requestProvider
        .get('/appointment/get-own-appointments')
}

const filterAppointments = (list) => {
    return requestProvider
        .post('appointment/filter', list)
}

const getAppointmentsInRange = (list) => {
    /**
     *  employee,
     *  startDate,
     *  endDate
     */
    return requestProvider
        .post('appointment/range-filter', list);
}

const getAppointmentWithPage = (list) => {
    return requestProvider
        .post('appointment/page-filter', list)
}

export {filterAppointments, getAllAppointment, createAppointment, deleteAppointment, updateAppointment, getAppointmentById, getOwnAppointments, getAppointmentsInRange, getAppointmentWithPage}